var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export let pathConfig = undefined;
const getConfigPath = () => {
    var _a;
    const searchParams = new URLSearchParams(window.location.search);
    if (process.env.MODE === "development") {
        const suffix = (_a = searchParams.get("apexconfig")) !== null && _a !== void 0 ? _a : "";
        if (suffix) {
            return `../config-${suffix}.json`;
        }
    }
    return "../config.json";
};
export const fetchNexusConfig = () => __awaiter(void 0, void 0, void 0, function* () {
    let configResponse = yield fetch(getConfigPath());
    if (process.env.MODE === "development") {
        if (!configResponse.ok) {
            configResponse = yield fetch("https://d3nsdzdtjbr5ml.cloudfront.net/casino/nexus/config.json");
        }
    }
    const responseData = yield configResponse.json();
    pathConfig = responseData;
    return responseData;
});
